import { render, staticRenderFns } from "./TermsConsent.vue?vue&type=template&id=5d1e24b6&scoped=true&"
import script from "./TermsConsent.vue?vue&type=script&lang=js&"
export * from "./TermsConsent.vue?vue&type=script&lang=js&"
import style0 from "./TermsConsent.vue?vue&type=style&index=0&id=5d1e24b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1e24b6",
  null
  
)

export default component.exports